import { AlertController, IonicSafeString } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastsService } from 'src/app/services/toasts/toasts.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NavController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { EventsService } from '../events/events.service';
import { IdleService } from './idle.service';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {

  constructor(
    public navController: NavController,
    public translate: TranslateService,
    public router: Router,
    public toastService: ToastsService,
    public authService: AuthService,
    public alertController: AlertController,
    public idleService: IdleService,
    public events: EventsService
  ) { }

  public goTo(pageName: string): void {
    this.navController.navigateForward(pageName);
  }

  public logout(): void {
    this.authService.logout().subscribe(
      res => {
        this.router.navigateByUrl('/home')
        this.toastService.presentToast(
          this.translate.instant("home.toasts.logout"),
          2000,
          "secondary", 'top',
          'information-circle-outline');
      },
      err => {
        console.log("error logout")
      }
    )
  }

  public presentNoPrivateInfo() {
    this.alertController.create({
      message: `
          <div>
            <p class='rose-icon title-bold-text'>${this.translate.instant("personal-data-add.toasts.userProfile")}</p>
            </div>
          <div>
            <p class='subTitle-text'>${this.translate.instant("personal-data-add.toasts.userProfileError")}</p>
          </div>`,
      backdropDismiss: false,
      cssClass: "privateInfoHelpersAlert",
      animated: true,
      buttons: [
        {
          text: this.translate.instant("generic.cancel"),
          cssClass: "flex-center ghost-button",
          handler: () => {
            this.logout()
          },
        },
        {
          text: this.translate.instant("generic.ok"),
          cssClass: "alert-button-custom flex-center",
          handler: () => {
            this.goTo("personal-data-add");
          }
        }
      ]
    }).then((res) => {
      res.present();
    });;
  }

  public presentNoPaymentInfo(cancel_page) {
    let title = this.translate.instant("generic.noPayments.alertTitle");
    let content = this.translate.instant("generic.noPayments.alertContent");
    this.alertController.create({
      message: new IonicSafeString(`
          <div>
          <img class="" src="assets/img/paycard.svg" alt="Alert no payment user profile"></img>
        </div>
          <div>
            <p class='rose-icon title-bold-text'>${title}</p>
            </div>
          <div>
            <p class='subTitle-text'>${content}</p>
          </div>`),
      backdropDismiss: false,
      cssClass: "noPaymentAlertHelper",
      animated: true,
      buttons: [
        {
          text: this.translate.instant("generic.cancel"),
          cssClass: "flex-center ghost-button",
          handler: () => {
            this.goTo(cancel_page);
          },
        },
        {
          text: this.translate.instant("generic.ok"),
          cssClass: "alert-button-custom flex-center",
          handler: () => {
            this.goTo("pay-cards");
          }
        }
      ]
    }).then((res) => {
      res.present();
    });;
  }

  public parseDateTimeStringToTimeString(datetimestring: string): string {
    const datetimelist = datetimestring.split(" ");
    if (datetimelist.length < 2) return "";

    const timelist = datetimelist[1].split(":");
    if (timelist.length < 2) return "";

    const timestring = timelist[0] + ":" + timelist[1];
    return timestring;
  }

  public hoursFromDate(date: string): string {
    const dateObject = new Date(date);

    const hours = ('0' + dateObject.getHours()).slice(-2);
    const minutes = ('0' + dateObject.getMinutes()).slice(-2);

    const hoursFormatted = `${hours}:${minutes}`;

    return hoursFormatted;
  }

  public dateTimeToDate(date: string): string {
    const dateObject = new Date(date);

    const day = ('0' + dateObject.getDate()).slice(-2);
    const month = ('0' + (dateObject.getMonth() + 1)).slice(-2); // Meses van de 0 a 11
    const year = dateObject.getFullYear().toString().slice(-2);

    const dateFormatted = `${day}/${month}/${year}`;

    return dateFormatted;
  }

  public sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public inactiveTimeoutHelper(onInactive: any, inactivityTime: number, popupTime: number){
    let title = this.translate.instant("generic.alerts.idleTime.title");
    let content = this.translate.instant("generic.alerts.idleTime.content");
    this.idleService.stopInactivityDetection();
    this.idleService.setInactivityTime(inactivityTime);
    this.idleService.initializeInactivityDetection(async () => {
      var alertTimeout = null;
      const alert = await this.alertController.create({
        cssClass: "inactivityAlert",
        animated: true,
        message: new IonicSafeString(`<div><img class="w-75" src="assets/img/booking-tour/slide5.svg" alt=""></img></div><div><p class="font-bold rose-icon big-icon-size">${title}</p></div><div><p class="medium-icon-size">${content}</p></div>`),
        buttons: [{
            text: 'OK',
            handler: () => {
              alert.dismiss();
              if (alertTimeout) clearTimeout(alertTimeout);
            }
          }],
        backdropDismiss: false,
      });
      alertTimeout = setTimeout(()=>{
        alert.dismiss();
        onInactive();
      }, popupTime);
      await alert.present();
    });
  }

}
